export const PLANS_ARRAY = {
  offer: [
    {
      slug: "basic",
      display: true,
      price: {
        pl: {
          value: 349,
          currency: "PLN",
        },
        eur: {
          value: 99,
          currency: "EUR",
        },
        usd: {
          value: 99,
          currency: "USD",
        },
      },
      list: ["30-publish-days", "1-offer-boost"],
    },
    {
      slug: "extended",
      display: true,
      price: {
        pl: {
          value: 549,
          currency: "PLN",
        },
        eur: {
          value: 149,
          currency: "EUR",
        },
        usd: {
          value: 149,
          currency: "USD",
        },
      },
      list: ["30-publish-days", "2-offer-boost", "business-profile", "promotion-facebook"],
    },
    {
      title: "Plan premium",
      display: true,
      slug: "premium",
      price: {
        pl: {
          value: 759,
          currency: "PLN",
        },
        eur: {
          value: 199,
          currency: "EUR",
        },
        usd: {
          value: 199,
          currency: "USD",
        },
      },
      list: [
        "30-publish-days",
        "4-offer-boost",
        "business-profile",
        "promotion-facebook",
        "ads-social-media",
        "individual-consultant",
        "surveys",
        "external-apply",
      ],
    },
    {
      slug: "draft",
      display: true,
      price: {
        pl: {
          value: 0,
          currency: "PLN",
        },
        eur: {
          value: 0,
          currency: "EUR",
        },
        usd: {
          value: 0,
          currency: "USD",
        },
      },
      list: ["30-publish-days"],
    },
  ],
  jumper: [
    {
      slug: "jumper_basic",
      display: false,
      price: {
        pl: {
          value: 99,
          currency: "PLN",
        },
        eur: {
          value: 29,
          currency: "EUR",
        },
        usd: {
          value: 29,
          currency: "USD",
        },
      },
      list: ["30-publish-days"],
    },
    {
      slug: "jumper_extended",
      display: true,
      price: {
        pl: {
          value: 149,
          currency: "PLN",
        },
        eur: {
          value: 49,
          currency: "EUR",
        },
        usd: {
          value: 49,
          currency: "USD",
        },
      },
      list: [
        "30-publish-days",
        "business-profile",
        // "promotion-facebook",
      ],
    },
    {
      title: "Plan premium",
      display: false,
      slug: "jumper_premium",
      price: {
        pl: {
          value: 249,
          currency: "PLN",
        },
        eur: {
          value: 99,
          currency: "EUR",
        },
        usd: {
          value: 99,
          currency: "USD",
        },
      },
      list: [
        "30-publish-days",
        "business-profile",
        "promotion-facebook",
        "ads-social-media",
        "individual-consultant",
        "surveys",
        "external-apply",
      ],
    },
  ],
}

export const getPlan = (type: "offer" | "jumper", str: string) => {
  return PLANS_ARRAY[type]?.find(el => el.slug === str)
}
